import Bowser from 'bowser';
import _get from 'lodash/get';

const parser = Bowser.parse(window.navigator.userAgent);
const ENGINE_MAP = Bowser.ENGINE_MAP;
const engine = _get(parser, 'engine.name');
const browserName = _get(parser, 'browser.name');

export const browserInfo = {
  msie: browserName === 'Internet Explorer', // {"browser":{"name":"Internet Explorer","version":"11.0"}}
  edgeLegacy: engine === ENGINE_MAP.EdgeHTML && browserName === 'Microsoft Edge', // {"browser":{"name":"Microsoft Edge","version":"18.18363"}
  safari: browserName === 'Safari'
};
